import React from 'react';
import ReactDOM from 'react-dom';
//import DashboardsStartUp from './components/organisms/DashboardsStartUp/DashboardsStartUp';
import App from './App';

// ReactDOM.render(<DashboardsStartUp />, document.getElementById('root'));
ReactDOM.render(<App />, document.getElementById('root'));
